module.exports = __webpack_public_path__ + "img/top3@2x.2fa674a8.png";